import { getIcon } from "@/lib/icon-map";
import { cn } from "@/lib/utils";

interface DynamicIconProps {
  name: string;
  className?: string;
}

export function DynamicIcon({ name, className }: DynamicIconProps) {
  const Icon = getIcon(name);

  if (!Icon) {
    if (import.meta.env.DEV) {
      console.warn(`Icon "${name}" not found in icon map`);
    }
    return null;
  }

  return <Icon className={cn("h-4 w-4", className)} />;
}
